import './css/style.scss';

function findAncestor (el, sel) {
  while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
  return el;
}

function animateElement(element) {
  if (element.style.maxHeight){
    element.style.maxHeight = null;
  } else {
    element.style.maxHeight = element.scrollHeight + "px";
  }
}

function getIngredientInfo(parent) {
  const url = parent.dataset.ingredientUrl;
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.send();

  xhr.onreadystatechange = processRequest;

  function processRequest(e) {
    if (xhr.readyState === 4 && xhr.status === 200) {
      parent.insertAdjacentHTML('beforeend', xhr.responseText);
      animateElement(parent.children[1]);
    }
  }
}

document.addEventListener("click", function(event){
  const appIcon = findAncestor(event.target, '.app-icon');
  if (appIcon) return;

  const parent = findAncestor(event.target, '.td-ingredient');
  if (!parent) return;
  // if the parent has 2 children, the last child is the description
  // previously fetched from the backend
  const content = parent.children[1];
  if (!content) {
    // make a request to the backend to fetch ingredient details
    getIngredientInfo(parent)
  } else {
    animateElement(content)
  }
});
